import { render } from "./insights-left-panel-lite.vue?vue&type=template&id=bff92bab"
import script from "./insights-left-panel-lite.vue?vue&type=script&lang=js"
export * from "./insights-left-panel-lite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__